import type { PrimaryFilterId } from '../../../filters/types/filters';
import type { TreemapDrilldownSegment } from '../../../filters/utils/treemapDrilldownLevels';
import { dimensionFromPrimaryFilter } from '../../DataResolver/convert-composition-v4-data';

const ICICLE_SEGMENTS = [
  'role',
  'geography',
  'rics',
  'skills',
  'activities',
] as const satisfies readonly TreemapDrilldownSegment[];

export type IcicleSegment = (typeof ICICLE_SEGMENTS)[number];

const isIcicleSegment = (
  dimension: string | undefined
): dimension is IcicleSegment =>
  ICICLE_SEGMENTS.includes(dimension as IcicleSegment);

export const getIcicleSegment = (
  primaryFilterId: PrimaryFilterId,
  secondaryDimension: string | undefined
): IcicleSegment => {
  if (isIcicleSegment(secondaryDimension)) return secondaryDimension;
  const own = dimensionFromPrimaryFilter(primaryFilterId);
  return isIcicleSegment(own) ? own : 'role';
};
